import { Outlet, useLocation } from 'react-router-dom';
import HeaderNav from '@/components/HeaderNav';
import Footer from '@/components/Footer';

export default function PublicLayout() {
  const location = useLocation();
  
  // Hide footer during quote intake flow (focused experience)
  const hideFooter = location.pathname === '/quote';
  
  return (
    <div className="min-h-screen bg-[hsl(var(--background))]">
      <HeaderNav />
      <main>
        <Outlet />
      </main>
      {!hideFooter && <Footer />}
    </div>
  );
}
